import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";

const Footer = () => {
  const year = new Date() ;
  const getFullYear = year.getFullYear() ;
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <section className="bg-dark text-white">
        <div className="d-flex justify-content-between align-items-center py-3 px-3 px-md-4">
          <div>
            © {getFullYear} Copyright MyNumber - {t.copyright}
          </div>
          <div className="d-flex gap-3">
            <a
              href="https://www.instagram.com/mynumberazerbaijan?igsh=NDFhd3o3c25vaG5y&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i
                className="fa-brands fa-instagram"
                style={{ fontSize: "24px", color: "#E4405F" }}
              ></i>
            </a>
            <a
              href="https://www.facebook.com/share/1D4pc5Pvfr/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i
                className="fa-brands fa-facebook"
                style={{ fontSize: "24px", color: "#1877F2" }}
              ></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
